import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Header = _resolveComponent("Header");

  var _component_router_view = _resolveComponent("router-view");

  var _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Header), _createVNode(_component_router_view), _createVNode(_component_Footer)], 64);
}